import { useState } from "react"
import { useNavigate } from "react-router-dom"
import useStore from "../../../store"
import { NeutralButton } from "../../common/Buttons"
import Spinner from "../../common/Spinner"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"

const isEligibleForConditionReport = (dealer) => {
  const isCollectionDealer = dealer?.attributes?.['active-status'] === 'Collection'
  const isHighRiskAccount = dealer?.attributes?.['high-risk-account'] === true

  return isCollectionDealer || isHighRiskAccount
}

export default function ConditionReportButton() {
  const navigate = useNavigate()
  const dealer = useStore((state) => state.dealer)
  const unit = useStore((state) => state.unit)
  const createFieldAudit = useStore((state) => state.createFieldAudit)

  const [isCreatingConditionReport, setIsCreatingConditionReport] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  if (!isEligibleForConditionReport(dealer)) {
    return null
  }

  const handleConfirm = () => {
    if (isCreatingConditionReport) { return }

    setIsCreatingConditionReport(true)
    createFieldAudit({
      dealer_id: dealer?.id,
      unit_ids: [unit.id],
      audit_type: 7,
    }, (fieldAudit) => {
      navigate(`/field_audits/${fieldAudit.id}`)
      setIsCreatingConditionReport(false)
    })
  }

  return (
    <>
      <NeutralButton
        text={isCreatingConditionReport ? <Spinner height="25px" /> : 'Start Condition Report'}
        onClick={() => setIsOpen(true)}
      />
      <ActionConfirmDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCancel={() => setIsOpen(false)}
        onConfirm={handleConfirm}
        isConfirming={isCreatingConditionReport}
        title={`Condition Report ${dealer?.attributes?.name ?? ''}`.trim()}
        body="Start a condition report for this unit?"
      />
    </>
  )
}
